module.exports = __webpack_public_path__ + "static/img/5.6ea9b60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/5.png
// module id = /8zo
// module chunks = 0